import React from 'react';
import { motion } from 'framer-motion';

export const PageHeader = ({ title, intro, actions, breadcrumb }) => {
  return (
    <div className="mb-10 space-y-4">
      {breadcrumb && (
        <div className="flex items-center gap-2 text-[10px] font-semibold text-slate-400 uppercase tracking-widest">
          {breadcrumb}
        </div>
      )}
      <div className="flex flex-col md:flex-row justify-between items-start md:items-end gap-6">
        <motion.div 
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          className="max-w-3xl"
        >
          <h1 className="text-3xl font-semibold text-slate-900 tracking-tight leading-none mb-3">
            {title}
          </h1>
          <p className="text-slate-500 text-lg leading-relaxed font-medium">
            {intro}
          </p>
        </motion.div>
        {actions && (
          <motion.div 
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            className="flex gap-3 shrink-0"
          >
            {actions}
          </motion.div>
        )}
      </div>
      <div className="h-px w-full bg-gradient-to-r from-slate-200 via-slate-100 to-transparent" />
    </div>
  );
};